import React, { Component } from 'react'

class DragAndDrop extends Component {
    dropRef = React.createRef();
    state = {
        dragging: false,
    };

    handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragIn = (e) => {
        console.log(e.dataTransfer.items.length);
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({dragging: true})
        }
    };

    handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter > 0) return;
        this.setState({dragging: false});
    };

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({drag: false});
        if (e.dataTransfer.files && e.dataTransfer.files.length === 1) {
            this.props.handleDrop(e.dataTransfer.files[0]);
            e.dataTransfer.clearData();
            this.dragCounter = 0;
        }
    };

    componentDidMount() {
        let div = this.dropRef.current;
        this.dragCounter = 0;
        div.addEventListener('dragenter', this.handleDragIn);
        div.addEventListener('dragleave', this.handleDragOut);
        div.addEventListener('dragover', this.handleDrag);
        div.addEventListener('drop', this.handleDrop);
    }
    componentWillUnmount() {
        let div = this.dropRef.current;
        div.removeEventListener('dragenter', this.handleDragIn);
        div.removeEventListener('dragleave', this.handleDragOut);
        div.removeEventListener('dragover', this.handleDrag);
        div.removeEventListener('drop', this.handleDrop);
    }
    render() {
        return (
            <div ref={this.dropRef}>
                {this.props.children}
            </div>
        )
    }
}
export default DragAndDrop



// WEBPACK FOOTER //
// ./src/components/DragAndDrop/DragAndDrop.js